import { Box } from '@mui/material';
import useUserData from 'hooks/useUserData';
import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import RenderCompanyConfig from './RenderCompanyConfig';
import BackPageButton from 'components/utils/BackPageButton';
import { useConfigQuery } from '@buildwise/libs/configurations';

function CompanyCustomConfig() {
  const { companyId } = useUserData();
  const { configName = '' } = useParams();
  const { configs } = useConfigQuery({ companyId });
  const { state } = useLocation();

  const config = useMemo(() => {
    return configs.find((config) => config.configName === configName && config?.id === state?.id);
  }, [configs, configName]);

  return (
    <Box>
      <BackPageButton sx={{ marginLeft: 2 }} />
      {!!config && <RenderCompanyConfig key={config.id} config={config} />}
    </Box>
  );
}

export default CompanyCustomConfig;
